import { Injectable } from '@angular/core';
import { EnrichmentAccordion, EnrichmentAccordionElement } from 'src/app/models/EnrichmentCollapse';
import { LabeledValue } from 'src/app/models/LabeledValue';
import { ODDetailResponse } from 'src/app/models/OpenData.ODDetailResponse';
import { ANOS_EMPRESA_ACTUAL, DELPHI_SCORE, FACTURACION, INGRESOS, NUM_ANOS_EMPRESA_ACTUAL_MOCK, RESUMEN_OPEN_DATA, RESUMEN_OPEN_DATA_MOCK } from 'src/app/shared/constants/freelancer-feasibility.constants';
import { DOCUMENT_NAMES_TO_REMOVE } from 'src/app/shared/constants/standard-documents-constants';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class StandardRequestDetailDocumentsService {

    documentNames: string[] = [];
    enrichmentAccordion: EnrichmentAccordion[] = [];
    activedAccordionItems: number[] = [];

    setDocumentNames(response: ODDetailResponse): void {
        this.documentNames = [];

        for (const key in response.documents) {
            if (!DOCUMENT_NAMES_TO_REMOVE.includes(key)) {
                this.documentNames.push(key);
            }
        }

        for (const key in response.data) {
            if (!this.documentNames.includes(key) && !DOCUMENT_NAMES_TO_REMOVE.includes(key)) {
                this.documentNames.push(key);
            }
        }
    }

    addDataToAccordion(title: string, data: LabeledValue[]): void {
        const elements: EnrichmentAccordionElement[] = [];
        data.forEach(item => {
            elements.push({ key: item.label, value: item.value });
        });
        this.enrichmentAccordion.push({ title: title, elements: elements });
    }

    clearAccordion(): void {
        this.enrichmentAccordion = [];
    }

    addEnrichmentDataToAccordion(enrichment: ODDetailResponse): void {
        this.enrichmentAccordion = [];
        const data = enrichment.data;
        const score = data['Score'];
        let D4A: string | null = null;
        if (score) {
            D4A = score['puntuacion'] ?? null;
        }
        const calculos = data['Calculos'];
        const facturacion: number = calculos['Facturacion'];
        const OD_Ingresos: number = calculos['OD_Ingresos'];

        if (environment.production){
            const OD_NUMANOEMPACTUAL: number = calculos['OD_NUMANOEMPACTUAL'];
            // const D4A: string = calculos['D4A'].trim();

            const elements: EnrichmentAccordionElement[] = [];
            elements.push({ key: FACTURACION, value: facturacion });
            elements.push({ key: ANOS_EMPRESA_ACTUAL, value: OD_NUMANOEMPACTUAL });
            elements.push({ key: INGRESOS, value: OD_Ingresos });
            if (D4A) {
                elements.push({ key: DELPHI_SCORE, value: D4A });
            }
            this.enrichmentAccordion.push({ title: RESUMEN_OPEN_DATA, elements: elements });
        } else {
            // MOCK DATA
            const elements: EnrichmentAccordionElement[] = [];
            elements.push({ key: FACTURACION, value: facturacion });
            elements.push({ key: ANOS_EMPRESA_ACTUAL, value: NUM_ANOS_EMPRESA_ACTUAL_MOCK });
            elements.push({ key: INGRESOS, value: OD_Ingresos });
            if (D4A) {
                elements.push({ key: DELPHI_SCORE, value: D4A });
            }
            this.enrichmentAccordion.push({ title: RESUMEN_OPEN_DATA_MOCK, elements: elements });
        }

        // dictionary keys of Enrichment
        for (const key in enrichment.enrichment) {
            const elements: EnrichmentAccordionElement[] = [];

            // every key in the dictionary
            for (const secondKey in enrichment.enrichment[key]) {
                elements.push({ key: secondKey, value: enrichment.enrichment[key][secondKey] });
            }
            this.enrichmentAccordion.push({ title: key, elements: elements });
        }
    }

    addFeasibilityEnrichmentDataToAccordion(feasibilityInfo: Record<string, any>): void {
        const elements: EnrichmentAccordionElement[] = [];
        for (const key in feasibilityInfo) {
            if (key !== 'rules') {
                elements.push({ key: key, value: feasibilityInfo[key] });
            }
        }
        this.enrichmentAccordion.push({ title: 'REQUEST_DETAIL.FEASIBILITY_RESULT', elements: elements });
    }

    onTabOpen(index: number): void {
        if (!this.activedAccordionItems.includes(index)) {
            this.activedAccordionItems.push(index);
        }
    }

    onTabClose(index: number): void {
        this.activedAccordionItems = this.activedAccordionItems.filter(i => i !== index);
    }

    expandAll(): void {
        this.activedAccordionItems = this.enrichmentAccordion.map((_, index) => index);
    }

    colapseAll(): void {
        this.activedAccordionItems = [];
    }
}
